import { render, staticRenderFns } from "./CreateExamineInfo.vue?vue&type=template&id=64bfcb45&scoped=true"
import script from "./CreateExamineInfo.vue?vue&type=script&lang=js"
export * from "./CreateExamineInfo.vue?vue&type=script&lang=js"
import style0 from "./CreateExamineInfo.vue?vue&type=style&index=0&id=64bfcb45&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bfcb45",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64bfcb45')) {
      api.createRecord('64bfcb45', component.options)
    } else {
      api.reload('64bfcb45', component.options)
    }
    module.hot.accept("./CreateExamineInfo.vue?vue&type=template&id=64bfcb45&scoped=true", function () {
      api.rerender('64bfcb45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Examine/CreateExamineInfo.vue"
export default component.exports